// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8688":"9923b5b2","8962":"d1a2fe7a"}[chunkId] + ".chunk.css";
};